import axios from 'axios';

export const FETCH_SPONSORS_LIST_START = 'FETCH_SPONSOR_LIST_START';

export const FETCH_SPONSORS_LIST_SUCCESS = 'FETCH_SPONSOR_LIST_SUCCESS';

export const FETCH_SPONSORS_LIST_ERROR = 'FETCH_SPONSOR_LIST_ERROR';

export function createFetchListStartAction() {
  return {
    type: FETCH_SPONSORS_LIST_START
  };
}

export function createFetchListErrorAction(error) {
  return {
    type: FETCH_SPONSORS_LIST_ERROR,
    payload: {
      error: error
    }
  };
}

export function createFetchListSucccessAction(data) {
  return {
    type: FETCH_SPONSORS_LIST_SUCCESS,
    payload: {
      list: data
    }
  };
}

export function fetchSponsorsList() {
  return dispatch => {
    dispatch(createFetchListStartAction());
    return axios
      .get(process.env.REACT_APP_API_URL + '/api/v1/sponsor')
      .then(response => {
        if (response.status !== 200) {
          dispatch(createFetchListErrorAction(response.error));
          return;
        }
        dispatch(createFetchListSucccessAction(response.data));
      })
      .catch(error => {
        dispatch(createFetchListErrorAction('CONNECTION_ERROR'));
      });
  };
}



// WEBPACK FOOTER //
// ./src/Actions/SponsorsList.js